<div>
  <app-questions-filter
    [categories]="categories"
    (search)="searchQuestions($event)">
  </app-questions-filter>
  <mat-divider></mat-divider>
  <app-questions-table *ngIf="questions"
    [categories]="categories"
    [questions]="questions.content"
    [pageSize]="questions.size"
    [totalElements]="questions.totalElements"
    (loadQuestions)="loadQuestions($event)"
    (updateQuestionStatus)="updateQuestionStatus($event)">
  </app-questions-table>
</div>
